import { ApolloError, gql, useLazyQuery, useMutation } from "@apollo/client";
import { Order } from "../gql/graphql";
import {
  CouponScope,
  CouponStatus,
  UserCouponStatus,
} from "../constants/props";

const LIST_USER_COUPON_QUERY = gql`
  query listUserCoupon($input: ListUserCouponInput!) {
    listUserCoupon(input: $input) {
      ok
      err
      coupons {
        isAvailable
        userCouponId
        userCouponStatus
        unavailableReason
        coupon {
          id
          name
          scope
          status
          validFrom
          validUntil
          discountPrice
          description
          code
          linkService {
            id
            name
          }
          corporation {
            id
            name
          }
        }
      }
    }
  }
`;

export interface ListUserCouponInput {
  input: {
    userId: number;
    serviceId?: number;
    corporationId?: number;
  };
}

export interface ListUserCouponQuery {
  listUserCoupon: {
    ok: boolean;
    err: string;
    coupons: {
      isAvailable: boolean;
      userCouponId?: number;
      userCouponStatus?: UserCouponStatus;
      unavailableReason?: string;
      coupon: {
        id: string;
        name: string;
        scope: CouponScope;
        status: CouponStatus;
        validFrom: string;
        validUntil: string;
        discountPrice: number;
        description: string;
        code: string;
        linkService: {
          id: number;
          name: string;
        };
        corporation: {
          id: number;
          name: string;
        };
      };
    }[];
  };
}

export const useListUserCoupon = (
  onCompleted?: (data: ListUserCouponQuery) => void,
  onError?: (error: ApolloError) => void
) => {
  return useLazyQuery<ListUserCouponQuery>(LIST_USER_COUPON_QUERY, {
    onCompleted,
    onError,
    fetchPolicy: "network-only",
  });
};
